import request from '@/sheep/request';

const SleepApi = {
  // 获取夜间睡眠记录分页
  getNightRecordPage: (params) => request({
    url: '/operation/sleep-night-record/page',
    method: 'GET',
    params,
  }),

  // 获取今日夜间睡眠记录
  getTodayNightRecord: (params) => request({
    url: '/operation/sleep-night-record/today',
    method: 'GET',
    params
  }),

  // 创建夜间睡眠记录
  createNightRecord: (data) => request({
    url: '/operation/sleep-night-record/create',
    method: 'POST',
    data,
  }),

  // 更新夜间睡眠记录
  updateNightRecord: (data) => request({
    url: '/operation/sleep-night-record/update',
    method: 'PUT',
    data,
  }),

  // 获取周睡眠统计数据
  getWeekStats: (params) => request({
    url: '/operation/sleep-night-record/week-stats',
    method: 'GET',
    params,
  }),

  // 获取周睡眠效率数据
  getWeekEfficiency: (params) => request({
    url: '/operation/sleep-night-record/week-efficiency',
    method: 'GET',
    params,
  }),

  // 获取日间小睡记录分页
  getNapRecordPage: (params) => request({
    url: '/operation/sleep-nap-record/page',
    method: 'GET',
    params,
  }),

  // 获取指定日期的日间小睡记录列表
  getNapRecordListByDate: (params) => request({
    url: '/operation/sleep-nap-record/list-by-date',
    method: 'GET',
    params,
  }),

  // 创建日间小睡记录
  createNapRecord: (data) => request({
    url: '/operation/sleep-nap-record/create',
    method: 'POST',
    data,
  }),

  // 删除日间小睡记录
  deleteNapRecord: (params) => request({
    url: '/operation/sleep-nap-record/delete',
    method: 'DELETE',
    params,
  }),
};

export default SleepApi;
